import { FileUploadError, supportedFileTypes, supportedVideoFileTypes } from '../enums';
import { FileErrorMessageService } from './FileErrorMessageService';
const MAX_FILE_NAME_CHARACTER_LIMIT = 200;
export class FileValidationService {
    static validateFile({ file, maxFileSize, allowedFileTypes, maxVideoFileSize }) {
        var _a;
        if (((_a = file.name) === null || _a === void 0 ? void 0 : _a.length) > MAX_FILE_NAME_CHARACTER_LIMIT) {
            return FileUploadError.MAX_FILE_NAME_CHARACTER_LIMIT_EXCEEDED;
        }
        if (this.isFileTypeInvalid(file, allowedFileTypes)) {
            return FileUploadError.INVALID_FILE_TYPE;
        }
        const fileSizeValidationError = this.validateFileSize(file, maxFileSize, maxVideoFileSize);
        if (fileSizeValidationError) {
            return fileSizeValidationError;
        }
        return undefined;
    }
    static isVideoFile(file) {
        return FileValidationService.isAllowedFileType(supportedVideoFileTypes, file);
    }
    static validateFileSize(file, maxFileSize, maxVideoFileSize) {
        return this.FileErrorMessageService.errorMessage(file.size, this.isVideoFile(file), maxFileSize, maxVideoFileSize);
    }
    static isFileTypeInvalid(file, allowedFileTypes) {
        return ((allowedFileTypes && !this.isAllowedFileType(allowedFileTypes, file)) ||
            !this.isAllowedFileType(supportedFileTypes, file));
    }
    static isAllowedFileType(allowedFileTypes, file) {
        return this.isValidExtension(allowedFileTypes, file.name);
    }
    static isValidExtension(allowedFileTypes, fileName) {
        const extension = FileValidationService.getFileExtension(fileName);
        if (!extension) {
            return false;
        }
        return allowedFileTypes.some((allowedFileType) => {
            return allowedFileType.toUpperCase() === extension.toUpperCase();
        });
    }
    static getFileExtension(fileName) {
        return fileName === null || fileName === void 0 ? void 0 : fileName.slice((Math.max(0, fileName.lastIndexOf('.')) || Infinity) + 1);
    }
    static isVideoFileType(fileName) {
        return FileValidationService.isValidExtension(supportedVideoFileTypes, fileName);
    }
}
FileValidationService.FileErrorMessageService = new FileErrorMessageService();
//# sourceMappingURL=FileValidationService.js.map